import { useShare } from '../ShareContext';
import { HOME_PAGE_SHARE } from '../sharePayload';
import './HeaderShareButton.css';

/**
 * @param {{ location?: string, className?: string }} props
 */
export function HeaderShareButton({ location = 'header', className = '' }) {
  const { openShareModal } = useShare();

  return (
    <button
      type="button"
      className={`results-page__nav-link header-share-btn${className ? ` ${className}` : ''}`}
      onClick={() => openShareModal({ ...HOME_PAGE_SHARE, location })}
    >
      Share
    </button>
  );
}

/**
 * @param {{ onMenuClose?: () => void, location?: string }} props
 */
export function HeaderShareMenuItem({
  onMenuClose,
  location = 'header_menu',
}) {
  const { openShareModal } = useShare();

  function handleClick() {
    openShareModal({ ...HOME_PAGE_SHARE, location });
    onMenuClose?.();
  }

  return (
    <button
      type="button"
      role="menuitem"
      className="header-more-menu__link results-page__nav-link header-share-btn header-share-btn--menu"
      onClick={handleClick}
    >
      Share
    </button>
  );
}
